<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="md:text-xl text-center -mt-8 text-black-1 font-bold mb-3">
      Deposit Agreement
    </div>
    <div class="overflow-y-scroll h-96 font-normal">
      <div
        v-html="agreementData"
        style="word-break: normal"
        class="text-sm xl:text-base"
      ></div>
    </div>
    <div class="flex justify-between items-center mt-8">
      <o-button
        class="text-sm md:text-base w-full font-semibold hover:opacity-80"
        @click="proceedToDepositAmount"
        >I Agree</o-button
      >

      <!-- <div
        class="font-normal text-sm md:text-base mr-4  text-black-2 underline cursor-pointer"
        @click="$emit('closeDialog')"
      >
        Cancel
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'agreementDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    agreementData: {
      type: String
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '35%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    proceedToDepositAmount () {
      this.$emit('closeDialog')
      this.$emit('agreementConfirmed')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
>>> .el-input__inner:focus {
  border-color: #818799;
}
>>> .el-input__inner {
  background-color: var(--background);
  color: var(--text-1);
  height: 50px;
  border: 1px solid var(--text-5);
}
>>> .el-input__inner {
  border-radius: 8px;
  border-color: var(--text-5);
  height: 48px;
}
>>> .el-select .el-input__inner:focus {
  border-radius: 8px;
  border-color: #c7c8d2;
}
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
}
>>> .el-form-item {
  margin-bottom: 10px;
}
>>> .el-form-item__label {
  margin-bottom: -8px;
}
>>> .el-button:focus,
.el-button:hover {
  color: white;
  opacity: 0.8;
  border-color: #c7c8d2;
  background-color: var(--color-primary);
}
>>> .el-dialog {
  border-radius: 30px;
  padding: 5px;
  background-color: white;
}
</style>
